import CircularCheckbox from "@Components/Form/CircularCheckbox";
import Filter from "@Components/Icons/Filter2";
import Union from "@Components/Icons/Union";
import { Paper, Popper, Table as MuiTable, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, } from "@mui/material";
import React from "react";
import styles from "./index.module.scss";
const NO_RESULTS = {
    name: "No countries found.",
    code: "NO_RESULTS",
};
export default class Table extends React.Component {
    popupRef = React.createRef();
    popupFilterRef = React.createRef();
    constructor(props) {
        super(props);
        this.state = {
            openMenuId: "",
            openMenuFilterId: "",
            anchorEl: null,
            anchorFilterEl: null,
            currentGroup: {},
            filterType: {},
        };
    }
    componentDidUpdate(previousProps) {
        if (previousProps.countryGroupType !== this.props.countryGroupType) {
            this.clearFilters();
        }
    }
    clearFilters = () => {
        this.onFilterGroupChange("all", "");
    };
    handleClick = (event, id) => {
        if (this.state.openMenuId === id) {
            this.setState({ anchorEl: null, openMenuId: "" });
            return;
        }
        this.setState({
            anchorEl: event.currentTarget,
            openMenuId: id,
        });
    };
    handleClickFilter = (event, id) => {
        this.setState({
            anchorFilterEl: this.state.anchorEl ? null : event.currentTarget,
            openMenuFilterId: this.state.openMenuFilterId === id ? "" : id,
        });
    };
    onFilterGroupChange = (filterType, currentGroup) => {
        this.setState({
            filterType: {
                ...this.state.filterType,
                [this.props.tabValue]: filterType,
            },
            currentGroup: {
                ...this.state.currentGroup,
                [this.props.tabValue]: filterType === "all" ? "" : currentGroup,
            },
            anchorFilterEl: null,
            openMenuFilterId: "",
        });
    };
    handleClickOutsidePopup = (event) => {
        const target = event.target;
        if (target.getAttribute("aria-describedby") !== "popup" &&
            target.parentElement.getAttribute("aria-describedby") !== "popup" &&
            this.popupRef.current &&
            !this.popupRef.current.contains(target)) {
            this.setState({
                anchorEl: null,
                openMenuId: "",
            });
        }
    };
    handleClickOutsidePopupFilter = (event) => {
        const target = event.target;
        if (target.getAttribute("aria-describedby") !== "popupFilter" &&
            target.parentElement.getAttribute("aria-describedby") !==
                "popupFilter" &&
            this.popupFilterRef.current &&
            !this.popupFilterRef.current.contains(target)) {
            this.setState({
                anchorFilterEl: null,
                openMenuFilterId: "",
            });
        }
    };
    componentDidMount() {
        document.addEventListener("mousedown", (event) => {
            this.handleClickOutsidePopup(event);
            this.handleClickOutsidePopupFilter(event);
        });
    }
    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutsidePopup);
        document.removeEventListener("mousedown", this.handleClickOutsidePopupFilter);
    }
    render() {
        const matchedFilterGroup = this.props.rows[this.state.currentGroup[this.props.tabValue]] || {};
        let filteredCountries = this.props.countries.filter((country) => {
            const filterType = this.state.filterType[this.props.tabValue] || "all";
            let isShow = filterType === "all";
            const isSelected = filterType === "selected";
            const isUnselected = filterType === "unselected";
            isShow = isSelected
                ? matchedFilterGroup[country.code]
                : isUnselected
                    ? !matchedFilterGroup[country.code]
                    : isShow;
            return (country.name
                .toLowerCase()
                .includes(this.props.searchCountryValue.toLowerCase()) &&
                isShow);
        });
        if (filteredCountries.length === 0) {
            filteredCountries = [NO_RESULTS];
        }
        return (React.createElement(TableContainer, { component: Paper, className: styles.container },
            React.createElement(MuiTable, { "aria-label": "sticky table", stickyHeader: true, className: styles.table },
                React.createElement(TableHead, null,
                    React.createElement(TableRow, { className: styles.rowHeader },
                        React.createElement(TableCell, { className: `${styles.stickyHeader} ${styles.cell}` }, "Country"),
                        this.props.groupColumns.map((column) => (React.createElement(TableCell, { key: column.id, component: "th", align: "left", className: `${styles.cellHeader} ${styles.cell}` },
                            React.createElement("div", { className: styles.headerContent },
                                React.createElement(Tooltip, { title: column.name, placement: "top", arrow: true },
                                    React.createElement("p", null, column.name)),
                                React.createElement("button", { "aria-describedby": "popupFilter", className: styles.moreBtn, onClick: (event) => this.handleClickFilter(event, column.id) },
                                    React.createElement(Filter, null),
                                    this.state.currentGroup[this.props.tabValue] === column.id && (React.createElement("span", { className: styles.filterActive }))),
                                React.createElement(Popper, { id: "popupFilter", ref: this.popupFilterRef, open: this.state.openMenuFilterId ===
                                        column.id, sx: { zIndex: 5 }, anchorEl: this.state.anchorFilterEl },
                                    React.createElement("div", { className: styles.popperContentFilter },
                                        React.createElement("p", { className: styles.filterText }, "Filter:"),
                                        React.createElement("div", { className: styles.filterGroup },
                                            React.createElement("div", { className: `${styles.filterOption} ${!this.state
                                                    .currentGroup[this.props
                                                    .tabValue] ||
                                                    (this.state
                                                        .currentGroup[this.props
                                                        .tabValue] === column.id &&
                                                        this.state
                                                            .filterType[this.props
                                                            .tabValue] === "all")
                                                    ? styles.selected
                                                    : ""}`, onClick: () => this.onFilterGroupChange("all", column.id) }, "All"),
                                            React.createElement("div", { className: `${styles.filterOption} ${this.state
                                                    .currentGroup[this.props
                                                    .tabValue] === column.id &&
                                                    this.state
                                                        .filterType[this.props
                                                        .tabValue] === "selected"
                                                    ? styles.selected
                                                    : ""}`, onClick: () => this.onFilterGroupChange("selected", column.id) }, "Selected"),
                                            React.createElement("div", { className: `${styles.filterOption} ${this.state
                                                    .currentGroup[this.props
                                                    .tabValue] === column.id &&
                                                    this.state
                                                        .filterType[this.props
                                                        .tabValue] === "unselected"
                                                    ? styles.selected
                                                    : ""}`, onClick: () => this.onFilterGroupChange("unselected", column.id) }, "Unselected")))),
                                React.createElement("button", { "aria-describedby": "popup", className: styles.moreBtn, onClick: (event) => this.handleClick(event, column.id) },
                                    React.createElement(Union, null)),
                                React.createElement(Popper, { id: "popup", ref: this.popupRef, open: this.state.openMenuId ===
                                        column.id, sx: { zIndex: 5 }, anchorEl: this.state.anchorEl },
                                    React.createElement("div", { className: styles.popperContent },
                                        React.createElement("button", { onClick: () => {
                                                this.setState({
                                                    openMenuId: "",
                                                    anchorEl: null,
                                                });
                                                this.props.onCheckUnassignCountries(column);
                                            } }, "Include all unassigned countries"),
                                        React.createElement("button", { onClick: () => {
                                                this.setState({
                                                    openMenuId: "",
                                                    anchorEl: null,
                                                });
                                                this.props.onEdit(column);
                                            } }, "Edit group"),
                                        React.createElement("button", { onClick: () => {
                                                this.setState({
                                                    openMenuId: "",
                                                    anchorEl: null,
                                                });
                                                this.props.onDelete(column);
                                            } }, "Delete group"))))))))),
                React.createElement(TableBody, null, filteredCountries.map((country, index) => (React.createElement(TableRow, { key: country.name, className: index % 2 ? styles.oddRow : styles.evenRow },
                    React.createElement(TableCell, { component: "td", scope: "row", className: `${styles.cell} ${styles.stickyBodyCol} ${index % 2
                            ? styles.oddRow
                            : styles.evenRow}` }, country.code === NO_RESULTS.code ? (React.createElement("span", { className: styles.noResults }, country.name)) : (React.createElement("span", null, country.name))),
                    this.props.groupColumns.map((column) => {
                        if (country.code === NO_RESULTS.code) {
                            return (React.createElement(TableCell, { key: column.id, align: "left", className: styles.cell }));
                        }
                        return (React.createElement(TableCell, { key: column.id, align: "left", className: styles.cell },
                            React.createElement(CircularCheckbox, { checked: !!this.props.rows[column.id]?.[country.code], change: () => this.props.onCheck(country.code, column.id, !this.props.rows[column.id]?.[country.code]) })));
                    }))))))));
    }
}
